import { useAuditTrace } from "hooks/audit";
import { useCurrentUser } from "hooks/shared";
import { useEffect, useState } from "react";

type TraceVisitProps = {
    eventId?: number;
    description: string;
    data?: any;
    visible?: boolean;
}

const TraceVisit: React.FC<TraceVisitProps> = (props: TraceVisitProps) => {

    const {
        eventId,
        description,
        data,
        visible
    } = props;

    const writeTrace = useAuditTrace();
    const user = useCurrentUser();
    const [ sent, setSent ] = useState<boolean>(false);

    useEffect(() => {
        if (!user) return;
        if (sent) return;

        writeTrace({
            eventId,
            description: `VISITED - ${description}`,
            data: data ?? {},
            isVisible: visible ?? false
        });

        setSent(true);

        return () => {
            writeTrace({
                eventId,
                description: `LEFT - ${description}`,
                data: data ?? {},
                isVisible: visible ?? false
            });
            setSent(false);
        }
    }, [ user ]);

    return null;
};

export default TraceVisit;